import applicationActionDefinitions from "../App/actions";
import { actionDefinitionsToActions } from "../utils";

export const { Types, Creators } = actionDefinitionsToActions(applicationActionDefinitions, {
  prefix: "@@saltcompliance/",
});
